import { gql } from "@apollo/client";

export const SEARCH_QUERY = gql`
  query SuggestTaggedUsers($query: String, $page: Int) {
    suggestTaggedUsers(query: $query, page: $page) {
      hasNext
      objects {
        id
        firstName
        imageId
        lastName
        username
      }
      page
    }
  }
`;
